import { render, staticRenderFns } from "./MenuModelA.vue?vue&type=template&id=56c1887a"
import script from "./MenuModelA.vue?vue&type=script&lang=js"
export * from "./MenuModelA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports